import ErrorModal from '@components/error/ErrorModal';
import analytics from '@utils/analytics';
import api from '@utils/api';
import { motion } from 'framer-motion';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import customEventBus from '@common/scripts/libs/eventBus';
const ProductWishlistToggle = (props) => {
    const { t } = useTranslation();
    const [errorMessage, setErrorMessage] = useState();
    const currentId = useMemo(() => {
        var _a, _b;
        return (((_a = props.productColor) === null || _a === void 0 ? void 0 : _a.productId) || '') + (((_b = props.productSize) === null || _b === void 0 ? void 0 : _b.id) || '');
    }, [props.productColor, props.productSize]);
    const [status, setStatus] = useState(!!window.wishlistIds.find((pid) => pid.includes(currentId)));
    // add listener from outside via CustomEventBus
    useEffect(() => {
        const updateFunction = (data) => {
            var _a;
            // console.info('wishlist:update from:', currentId);
            setStatus(!!((_a = data === null || data === void 0 ? void 0 : data.wishlistIds) === null || _a === void 0 ? void 0 : _a.find((pid) => pid.includes(currentId))));
        };
        customEventBus.on('wishlist:update', updateFunction);
        return () => {
            customEventBus.off('wishlist:update', updateFunction);
        };
    }, [currentId]);
    useEffect(() => {
        const updatedStatus = !!window.wishlistIds.find((pid) => pid.includes(currentId));
        if (updatedStatus != status) {
            setStatus(updatedStatus);
        }
    }, [currentId]);
    const updateWishlistStatus = (items) => {
        if (items) {
            // setStatus(!!items.find((pid) => pid.includes(currentId)));
            customEventBus.emit('account:update', { wishlistIds: items });
            if (!props.inPublicWishlist) {
                customEventBus.emit('wishlist:update', { wishlistIds: items });
            }
        }
    };
    const toggleWishlist = () => {
        if (status) {
            api
                .removeFromWishlist(currentId)
                .then((data) => {
                if (data.success) {
                    updateWishlistStatus(data.items);
                }
                else {
                    setErrorMessage(data.errorMsg);
                }
            })
                .catch((res) => setErrorMessage(res));
        }
        else {
            api
                .addToWishlist(currentId)
                .then((data) => {
                var _a, _b;
                if (data.success) {
                    updateWishlistStatus(data.items);
                    analytics.saveForLaterAddToWishlist(props.product, (_a = props === null || props === void 0 ? void 0 : props.productSize) === null || _a === void 0 ? void 0 : _a.id);
                    //analytics.addToWishlist(props.product.id)
                    analytics.wishlistInteraction((_b = props.product) === null || _b === void 0 ? void 0 : _b.masterId, props.section);
                }
                else {
                    setErrorMessage(data.errorMsg);
                }
            })
                .catch((res) => setErrorMessage(res));
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { "aria-label": !status ? t('button.saveforlater') : t('button.removefromwishlist'), className: 'wishlist-icon' + (props.modifierClass || ''), "aria-pressed": status, onClick: toggleWishlist, "data-color": props.color },
            React.createElement(motion.svg, { width: "24", height: "24", whileTap: { scale: 0.8 }, "aria-hidden": true },
                React.createElement(motion.path, { d: "m11.648 7.2187.352.349.352-.349.6121-.6069c1.4952-1.4824 3.9211-1.4824 5.4163 0 1.4928 1.4801 1.4928 3.878 0 5.3581L12 18.2959l-6.3804-6.326c-1.4928-1.4801-1.4928-3.878 0-5.358 1.4952-1.4825 3.9211-1.4825 5.4163 0l.6121.6067Z", stroke: props.color == 'white' ? '#FFF' : '#000', fill: status ? (props.color == 'white' ? '#FFF' : '#000') : 'none' }))),
        React.createElement(ErrorModal, { message: errorMessage, onClose: () => setErrorMessage(undefined) })));
};
export default ProductWishlistToggle;
